__turbopack_context__.v({
  "loading": "FolderSharingModalList-module__hH6YQa__loading",
  "root": "FolderSharingModalList-module__hH6YQa__root",
});
